import cn from 'classnames';
import { EMOJI_REGEXP } from '../../constants/regexp';

const hasValueClassName = 'TextFieldWrapper_hasValue';
const errorClassName = 'TextFieldWrapper_hasError';

/* eslint-disable no-useless-escape*/

// ***
// Поскольку мы превратили чекбокс в "глупый" - принудительно присваиваем ему
// className отмеченного чекбокса, чтобы к нему применились стили
// отмеченного чекбокса (только в случае, если он действительно отмечен)
function visualCorrection(trs, isModule) {
  // Оставляем только строки-некомментарии
  const trsWithoutComments = Array.from(trs).filter(
    tr => !Array.from(tr.classList).includes('commentRow')
  );

  // Добавляем classname серой строки каждой второй строчке + если какая-либо из этих строк содержит комментарий - ему тоже добавляем этот classname
  let isOdd = false;
  let counter = 0;

  trsWithoutComments.forEach((tr, rowIndex) => {
    const hasComment = Array.from(tr.classList).includes('withComment');
    const isSubsectionTitle = tr.classList.contains('subsection-title');
    const isCaptions = tr.classList.contains('captions');

    if (isSubsectionTitle || isCaptions) {
      isOdd = true;
    } else if (isOdd) {
      tr.classList.add('odd');

      if (hasComment) {
        tr.nextElementSibling.classList.add('odd');
      }

      isOdd = false;
      counter = 1;
    } else if (counter > 0) {
      if (counter % 2 === 0) {
        tr.classList.add('odd');

        if (hasComment) {
          tr.nextElementSibling.classList.add('odd');
        }
      }

      counter++;
    }
  });

  trs.forEach((tr, rowIndex) => {
    // Избавляемся от rowspan
    const tds = tr.querySelectorAll('td');
    tds.forEach((td, colIndex) => {
      if (td.rowSpan > 1) {
        for (let i = 1; i < td.rowSpan; i++) {
          trs[rowIndex + i].insertCell(colIndex);
        }
        td.rowSpan = 1;
      }
    });
  });
}

function updateRawTableComment(commentCell, taskNumber, tasksWithInformation) {
  if (!commentCell) {
    return;
  }

  // Находим элемент textarea для комментария
  const textarea = commentCell.querySelector('textarea');

  if (!textarea) {
    return;
  }

  // Ищем значение поля "комментарий" в redux state. Если не находим - оставляем значение элемента textarea
  const task = tasksWithInformation.find(
    task => task.task_number === taskNumber
  );
  // // Вставляем в элемент textarea корректное значение
  textarea.value = task ? task.comment : textarea.value;
}

function configureComment(args) {
  const {
    commentCell,
    onUpdateAppealData,
    taskNumber,
    taskName,
    testScore,
    primaryScore,
    answer,
    detailed,
    defaultValue
  } = args;
  // Находим элемент textarea для комментария
  const textarea = commentCell.querySelector('textarea');
  // Поскольку изначально textarea пустой - он невалидный, вешаем на него соответствующий класснейм
  // defaultValue может прийти в случае конфигурирования существовавшего прежде поля комментария,
  // в таком случае присваиваем это defaultValue аттрибуту value textarea, также
  // добавляя ему класснейм задействованного textarea
  if (!defaultValue) {
    textarea.parentElement.classList.add(errorClassName);
  } else {
    textarea.value = defaultValue;
    textarea.parentElement.classList.add(hasValueClassName);
  }

  // Вешаем на textarea eventListener, срабатывающий при вводе значения и меняющий
  // classname textarea на classname заполненности (для корректной работы placeholder'а),
  // а также извещающий redux state об изменении комментария
  const handleChange = e => {
    const { value, maxLength, parentElement } = e.target;
    const counter = parentElement.parentElement.querySelector(
      '.TextArea_counter'
    );

    if (value) {
      parentElement.classList.add(hasValueClassName);
      parentElement.classList.remove(errorClassName);
    } else {
      parentElement.classList.remove(hasValueClassName);
      parentElement.classList.add(errorClassName);
    }

    if (counter) {
      const count = maxLength ? maxLength - value.length : value.length;
      const moreThan90Percent =
        maxLength && (value.length / maxLength) * 100 > 90;

      counter.className = cn('TextArea_counter', {
        warning: moreThan90Percent
      });
      counter.innerHTML = count;
    }

    onUpdateAppealData({
      comment: value.replace(EMOJI_REGEXP, ''),
      checked: true,
      changedTask: {
        answer,
        detailed,
        task_number: taskNumber,
        task_name: taskName,
        test_score: testScore,
        primary_score: primaryScore
      },
      blur: e.type === 'blur'
    });
  };

  textarea.addEventListener('input', handleChange);
  textarea.addEventListener('blur', handleChange);
}

export const processTable = args => {
  const {
    tableRawHtml,
    checkboxNode,
    commentNode,
    onUpdateAppealData,
    checkedTaskNumbers,
    tasksWithInformation,
    showOnlyIncorrect,
    indexOfTable
  } = args;
  // Если верстка почему-то не пришла - выходим из функции
  if (!tableRawHtml) {
    return;
  }

  // Получаем все tr вместе со строчками "Итого" и прочими
  const unfilteredTrs = tableRawHtml.querySelectorAll('tr');

  // Получаем тип таблицы
  const header = tableRawHtml.querySelector('.type-title');
  const detailed = header && header.innerText.includes('развернутым');

  const headerColspan = tableRawHtml
    .querySelector('.type-title td')
    ?.getAttribute('colspan');

  // Инициализируем переменные для подсчета баллов
  let sumYourScore = 0;
  let sumMaxScore = 0;

  let isModule = false;

  // Перебираем строки таблицы
  unfilteredTrs.forEach((tr, index) => {
    // Берем все столбцы из строки
    const unfilteredTds = tr.querySelectorAll('td');

    let commentRow = '';
    let commentCell = '';

    // Является ли таблица таблицей типа "Критерии"
    const isCriteriaTable = unfilteredTds.length === 5;

    // Является ли строка заголовком модуля?
    const isModuleCaption = tr.classList.contains('subsection-title');
    isModule = isModule || isModuleCaption;

    // Рассматриваем ли мы в данный момент первую строку этой таблицы
    const isFirstRowOfCriteriaTable = index === 1;

    if (isCriteriaTable && isFirstRowOfCriteriaTable) {
      // Даем css'у понять, что перед нами таблица типа "Критерии"
      tableRawHtml.classList.add('Table_criteria');
    }

    // Пропускаем первые 2 строки заголовков (3 для модулей), помечая их специальным класснеймом, чтобы не скрыть их при отображении только неправильных ответов
    document.querySelectorAll('.captions').forEach(element => {
      element.classList.add('Table_info');
    });
    if (index < (isModule ? 3 : 2) || isModuleCaption) {
      tr.classList.add('Table_info');
      if (isModuleCaption) {
        tr.classList.add('Table_moduleCaption');

        if (
          tr.nextElementSibling &&
          tr.nextElementSibling
            .querySelector('td')
            .innerText.includes('№ задания')
        ) {
          tr.nextElementSibling.after(tr);
        }
      }

      const titleCells = tr.querySelectorAll('td');

      Array.from(titleCells).forEach(td => {
        if (td.innerText.includes('Ваш балл')) {
          td.classList.add('user_score');
        }

        if (td.innerText.includes('Макс. балл')) {
          td.innerHTML = '<span style="white-space: nowrap;">Макс.</span> балл';
        }
      });

      return;
    }

    // Получаем столбец с нужными аттрибутами, в которых содержится информация о номере задачи и названии задачи
    const tdWithData = tr.querySelector('td[taskname]');

    // Удаляем строку с "Итого"
    if (
      unfilteredTds[0].innerText.includes('Итого') ||
      unfilteredTds[0].innerText.includes('Общее количество баллов') ||
      unfilteredTds[0].innerText.includes('за задания части')
    ) {
      tr.remove();
      return;
    }

    // Удаляем лишние строки в конце
    if (
      unfilteredTds.length < 4 &&
      (!tdWithData || !tr.classList.contains('commentRow'))
    ) {
      return;
    }

    // Достаем необходимые нам данные из столбца с данными задачи, а также конфигурируем чекбокс
    if (tdWithData) {
      // Узнаем, в какой столбец поставить чекбокс
      const indexOfCheckboxCell = isCriteriaTable ? 1 : 0;
      // Узнаем название задачи
      const taskName = tdWithData.getAttribute('taskname');
      // Узнаем краткое наименование задачи, необходимое нам в случае работы с галочкой "Только неправильные ответы"
      const taskShortName =
        tdWithData.getAttribute('taskshortname') ||
        unfilteredTds[indexOfCheckboxCell].innerText;
      // Узнаем номер задачи, уникален для каждого задания любой таблицы на странице
      const taskNumber = tdWithData.getAttribute('tasknumber');
      // Узнаем ответ пользователя
      const tdAnswers = tdWithData.previousSibling;
      const answer = tdAnswers.innerText;

      // Узнаем баллы пользователя
      const testScore = parseInt(tdWithData.innerText, 10);
      const primaryScore = tdWithData.nextElementSibling
        ? parseInt(tdWithData.nextElementSibling.innerText, 10)
        : 0;
      // Проверяем наличие текущего номера задачи в redux state, на основании чего делаем вывод, должен ли чекбокс быть отмечен
      // Состояние чекбокса могло поменяться в результате действий в таблице в модалке, поэтому эвент клика на чекбокс мог не сработать
      const isCheckedOnInitialization = checkedTaskNumbers.includes(taskNumber);

      // Если чекбокс уже был отмечен - сверяем значение поля "комментарий" в таблице со значением в redux state и, при необходимости, обновляем значение в таблице
      if (isCheckedOnInitialization) {
        // Находим строчку комментария для рассматриваемого tr'а
        const taskCommentCell = tr.nextElementSibling;
        // Обновляем комментарий, если нужно и возможно
        updateRawTableComment(
          taskCommentCell,
          taskNumber,
          tasksWithInformation
        );
      }

      // Узнаем, имеет ли данная строка поле комментария
      const isTrHasCommentField = !!(
        tr.nextElementSibling &&
        Array.from(tr.nextElementSibling.classList).includes('commentRow')
      );
      // Если чекбокс при вызове processTable не был checked, но поле комментария есть - удаляем это поле
      if (!isCheckedOnInitialization && isTrHasCommentField) {
        tr.nextElementSibling.remove();
      }
      // Если чекбокс при вызове processTable был checked, но поля комментария нет - добавляем это поле
      if (isCheckedOnInitialization && !isTrHasCommentField) {
        commentRow = tableRawHtml.insertRow(tr.rowIndex + 1);
        commentRow.className = tr.className;
        commentRow.classList.add('commentRow');
        tr.classList.add('withComment');
        commentCell = commentRow.insertCell(0);
        commentCell.colSpan = headerColspan;
        commentCell.innerHTML = commentNode.innerHTML;
        const currentTask = tasksWithInformation.find(
          task => task.task_number === taskNumber
        );
        const currentTaskComment = currentTask ? currentTask.comment : '';

        const params = {
          commentCell,
          onUpdateAppealData,
          taskNumber,
          taskName,
          testScore,
          primaryScore,
          answer,
          detailed,
          currentTaskComment
        };
        configureComment(params);
      }

      // Сохраняем краткий номер задачи в аттрибут
      tdWithData.setAttribute(
        'taskshortname',
        unfilteredTds[indexOfCheckboxCell].innerText
      );

      // В верстке компонента ModalTable внутри необходимого нам чекбокса записан текст-заглушка "%number%". Заменяем его на номер задачи
      let checkboxInnerHTML = checkboxNode.innerHTML.replace(
        '%number%',
        isCriteriaTable && showOnlyIncorrect ? taskName : taskShortName
      );

      // см комментарий ***
      if (isCheckedOnInitialization) {
        checkboxInnerHTML = checkboxInnerHTML.replace(
          'ant-checkbox-wrapper',
          'ant-checkbox-wrapper ant-checkbox-checked'
        );
      }

      // Вставляем чекбокс на место
      unfilteredTds[indexOfCheckboxCell].innerHTML = checkboxInnerHTML;

      // Чекбокс - это элемент типа input, так что далее описан эвент при клике на уже вставленный в предыдущем шаге чекбокс
      unfilteredTds[indexOfCheckboxCell].querySelector(
        'input'
      ).onclick = event => {
        // Поскольку наш чекбокс - сложный элемент в нескольких обертках - здесь мы получаем самую верхнюю обертку чекбокса (или, по сути, чекбокс целиком)
        const checkboxNode = event.target.parentElement.parentElement;

        // Проверяем наличие текущего номера задачи в redux state, на основании чего делаем вывод, отмечен ли чекбокс
        const isCheckedBeforeClick = checkedTaskNumbers.includes(taskNumber);

        // Далее описаны действия, которые необходимо совершить, если чекбокс перед кликом отмечен не был
        if (!isCheckedBeforeClick) {
          // Принудительно, с помощью класснейма делаем чекбокс отмеченным
          checkboxNode.classList.add('ant-checkbox-checked');

          // Добавляем в таблицу строчку для инпута комментария
          const commentRow = tableRawHtml.insertRow(tr.rowIndex + 1);

          // Наследуем класснейм от предыдущей строки (она может быть разных цветов
          // - в зависимости от баллов, полученных за задачу),
          // чтобы поле комментария было такого же цвета, как поле задачи
          commentRow.className = tr.className;
          // Помечаем tr, содержащий input комментария специальным classname'ом
          commentRow.classList.add('commentRow');

          // С помощью classname'а делаем поле комментария и задачи на вид одним целым
          tr.classList.add('withComment');
          // Добавляем в строчку комментария ячейку для комментария (вставляем td в tr)
          const commentCell = commentRow.insertCell(0);
          // Растягиваем наш td на всю ширину таблицы
          commentCell.colSpan = headerColspan;
          // Вставляем в добавленный td код компонента инпута комментария
          commentCell.innerHTML = commentNode.innerHTML;

          const params = {
            commentCell,
            onUpdateAppealData,
            taskNumber,
            taskName,
            testScore,
            primaryScore,
            answer,
            detailed
          };
          // Конфигурируем компонент комменатрия (вешаем event listeners, реагирующие на изменение значения input'а и взаимодействующие с redux state)
          configureComment(params);

          // Добавляем в redux state начальную информацию о поле задачи
          // (с пустым комментарием и отмеченным чекбоксом) и выходим из метода,
          // получив отмеченный чекбокс и поле для комментария
          return onUpdateAppealData({
            comment: '',
            checked: true,
            blur: true,
            changedTask: {
              answer,
              detailed,
              task_number: taskNumber,
              task_name: taskName,
              test_score: testScore,
              primary_score: primaryScore
            }
          });
        }

        // Далее идет код, который срабатывает в случае, если чекбокс перед кликом на него уже был отмечен
        // Поскольку мы удаляем поле комментария - убираем classname у tr, что он с комментарием
        tr.classList.remove('withComment');

        // Мы имеем доступ к строке с информацией о задаче, поэтому удаляем ее следующего соседа, который является строкой с комментарием
        tr.nextElementSibling.remove();

        // Удаляем у чекбокса classname отмеченности
        checkboxNode.classList.remove('ant-checkbox-checked');

        // Добавляем в redux state информацию, что задача теперь не отмечена и удаляем комментарий к этой задаче
        return onUpdateAppealData({
          comment: '',
          checked: false,
          blur: true,
          changedTask: {
            answer,
            detailed,
            task_number: taskNumber,
            task_name: taskName,
            test_score: testScore,
            primary_score: primaryScore
          }
        });
      };
    }

    // Парсим и суммируем баллы
    const yourScore =
      parseInt(unfilteredTds[unfilteredTds.length - 2].innerText, 10) || 0;
    const maxScore =
      parseInt(unfilteredTds[unfilteredTds.length - 1].innerText, 10) || 0;
    sumMaxScore += maxScore;
    sumYourScore += yourScore;

    // Помечаем строки специальными classname, отвечающими за цвет
    if (yourScore === 0 && !tr.classList.contains('captions')) {
      tr.classList.remove('Table__Row_partial');
      tr.classList.add('Table__Row_incorrect');
      if (commentRow) {
        commentRow.classList.remove('Table__Row_partial');
        commentRow.classList.add('Table__Row_incorrect');
      }

      return;
    }

    if (yourScore < maxScore) {
      tr.classList.remove('Table__Row_incorrect');
      tr.classList.add('Table__Row_partial');
      if (commentRow) {
        commentRow.classList.remove('Table__Row_incorrect');
        commentRow.classList.add('Table__Row_partial');
      }
    }
  });

  // Визуальная коррекция таблицы
  visualCorrection(unfilteredTrs, isModule);

  // Конфигурируем строку "Итого"
  const typeTitleRow = tableRawHtml.querySelector('tr.type-title td');
  const text = typeTitleRow ? typeTitleRow.textContent : '';
  let totalText;

  if (
    text.includes('заданий с кратким ответом') ||
    text.includes('заданий с развернутым ответом')
  ) {
    totalText = `c ${text.split('заданий с')[1]}`;
  } else {
    totalText = `части ${indexOfTable}`;
  }

  const totalRow = tableRawHtml.insertRow();
  totalRow.classList.add('sum');
  totalRow.classList.add('Table_info');
  const totalCell = totalRow.insertCell();
  totalCell.colSpan = unfilteredTrs[0].cells[0].colSpan - 2;
  totalCell.innerHTML = `<span class="Table_infoSum__desktop">Общее количество баллов</span>
    <span class="Table_infoSum__mobile">Баллов</span>
    за задания ${totalText}<span class="Table_infoSum__mobile">:</span>`;
  const yourCell = totalRow.insertCell();
  yourCell.innerText = sumYourScore;
  const maxCell = totalRow.insertCell();
  maxCell.innerText = sumMaxScore;
};
